const baseLambdaPDFDefaults = {
  displayEventLogo: false,
  displayEventTitle: true,
  displayShowTitle: true,
  displayTeamLogo: false,
  displayTeamTitle: true,
  includePrivateNoteContents: false,
  grayscale: false,
  guest: true,
  orientation: 'landscape',
  customPageBreaks: [],
  format: 'Letter',
  rowSize: 'Compact',
  twentyFourHour: false,
  timeZone: 'America/New_York',
};

function getPDFConfig(params) {
  const { hostname, origin } = window.location;
  let defaults = Object.assign({}, baseLambdaPDFDefaults, {
    hostname,
    origin,
    ...params,
  });

  return defaults;
}

export default {
  downloadTimestampsXLS(params, query) {
    _openExportUrl(params, 'xls/timestamps', query);
  },

  downloadXLS(params) {
    _openExportUrl(params, 'xls/generic');
  },

  downloadCustomXLS(params, query) {
    _openExportUrl(params, 'xls/custom', query);
  },

  downloadPersonalXLS(params, query) {
    _openExportUrl(params, 'xls/personal', query);
  },

  downloadCSV(params) {
    _openExportUrl(params, 'csv/generic');
  },

  downloadCustomCSV(params, query) {
    _openExportUrl(params, 'csv/custom', query);
  },

  downloadPersonalCSV(params, query) {
    _openExportUrl(params, 'csv/personal', query);
  },

  downloadPersonalPDF(params, query) {
    _openExportUrl(params, 'pdf/personal', query);
  },

  downloadGenericPDF(params, query) {
    _openExportUrl(params, 'pdf/generic', query);
  },

  downloadWord(params, query) {
    _openExportUrl(params, 'doc/script', query);
  },

  getGuestPDFConfig(params) {
    return getPDFConfig(params);
  },
};

function _openExportUrl(params, type, query) {
  const { teamId, eventId, showId } = params;

  let url = `${window.appExportEndpoint}/teams/${teamId}/events/${eventId}/shows/${showId}/${type}`;
  url = query ? `${url}${formatQueryString(query)}` : url;
  window.open(url);
}

/**
 * Format query string for uri
 */
function formatQueryString(query) {
  const qs = '?';
  const queries = [];

  Object.keys(query).forEach((key) => {
    queries.push(`${key}=${query[key]}`);
  });

  return qs + queries.join('&');
}
